import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sh-layout',
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  standalone: false
})
export class LayoutComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
